export const ru = {
    'active-banners': 'Активные объявления',
    'active-campaigns': 'Активные кампании',
    'active-cpc-campaigns': 'Активные кампании с оплатой за клики',
    'active-cpm-campaigns': 'Активные кампании c оплатой за показы',
    'active-groups': 'Активные группы',
    'active-many-campaigns-banners': 'Активные объявления {count} кампаний',
    'active-many-campaigns-groups': 'Активные группы {count} кампаний',
    'active-many-campaigns-phrases': 'Активные фразы {count} кампаний',
    'active-many-groups-banners': 'Активные объявления {count} групп',
    'active-many-groups-phrases': 'Активные фразы {count} групп',
    'active-one-campaign-banners': 'Активные объявления {count} кампании',
    'active-one-campaign-groups': 'Активные группы {count} кампании',
    'active-one-campaign-phrases': 'Активные фразы {count} кампании',
    'active-one-group-banners': 'Активные объявления {count} группы',
    'active-one-group-phrases': 'Активные фразы {count} группы',
    'active-phrases': 'Активные фразы',
    'active-single-campaign-banners': 'Активные объявления кампании {name}',
    'active-single-campaign-groups': 'Активные группы кампании {name}',
    'active-single-campaign-phrases': 'Активные фразы кампании {name}',
    'active-single-group-banners': 'Активные объявления группы {name}',
    'active-single-group-phrases': 'Активные фразы группы {name}',
    'active-some-campaigns-banners': 'Активные объявления {count} кампаний',
    'active-some-campaigns-groups': 'Активные группы {count} кампаний',
    'active-some-campaigns-phrases': 'Активные фразы {count} кампаний',
    'active-some-groups-banners': 'Активные объявления {count} групп',
    'active-some-groups-phrases': 'Активные Фразы {count} групп',
    'all-active-banners': 'Активные объявления',
    'all-active-campaigns': 'Активные кампании',
    'all-active-campaigns-title': 'Все активные кампании',
    'all-active-groups': 'Активные группы',
    'all-archived-banners': 'Архивные объявления',
    'all-archived-campaigns': 'Архивные кампании',
    'all-archived-campaigns-title': 'Все архивные кампании',
    'all-archived-groups': 'Архивные группы',
    'all-banners': 'Все объявления',
    'all-campaigns': 'Все кампании',
    'all-campaigns-title': 'Все кампании',
    'all-cpc-campaigns': 'Кампании с оплатой за клики',
    'all-cpm-campaigns': 'Кампании c оплатой за показы',
    'all-groups': 'Все группы',
    'all-phrases': 'Все фразы',
    'all-targetings': 'Все условия показа',
    'all-targetins': 'Все условия показа',
    'archive-banners': 'Архивные объявления',
    'archive-campaigns': 'Архивные кампании',
    'archive-cpc-campaigns': 'Архивные кампании с оплатой за клики',
    'archive-cpm-campaigns': 'Архивные кампании c оплатой за показы',
    'archive-groups': 'Архивные группы',
    'archive-phrases': 'Архивные фразы',
    'archived-many-campaigns-banners': 'Архивные объявления {count} кампаний',
    'archived-many-campaigns-groups': 'Архивные группы {count} кампаний',
    'archived-many-campaigns-phrases': 'Архивные фразы {count} кампаний',
    'archived-many-groups-banners': 'Архивные объявления {count} групп',
    'archived-many-groups-phrases': 'Архивные фразы {count} групп',
    'archived-one-campaign-banners': 'Архивные объявления {count} кампании',
    'archived-one-campaign-groups': 'Архивные группы {count} кампании',
    'archived-one-campaign-phrases': 'Архивные фразы {count} кампании',
    'archived-one-group-banners': 'Архивные объявления {count} группы',
    'archived-one-group-phrases': 'Архивные фразы {count} группы',
    'archived-single-campaign-banners': 'Архивные объявления кампании {name}',
    'archived-single-campaign-groups': 'Архивные группы кампании {name}',
    'archived-single-campaign-phrases': 'Архивные фразы кампании {name}',
    'archived-single-group-banners': 'Архивные объявления группы {name}',
    'archived-single-group-phrases': 'Архивные фразы группы {name}',
    'archived-some-campaigns-banners': 'Архивные объявления {count} кампаний',
    'archived-some-campaigns-groups': 'Архивные группы {count} кампаний',
    'archived-some-campaigns-phrases': 'Архивные фразы {count} кампаний',
    'archived-some-groups-banners': 'Архивные объявления {count} групп',
    'archived-some-groups-phrases': 'Архивные Фразы {count} групп',
    banners: 'Объявления',
    'cpc-campaigns': 'За клики',
    'cpm-campaigns': 'За показы',
    'many-campaigns-banners': 'Объявления {count} кампаний',
    'many-campaigns-groups': 'Группы {count} кампаний',
    'many-campaigns-phrases': 'Фразы {count} кампаний',
    'many-campaigns-targetings': 'Условия показа {count} кампаний',
    'many-groups-banners': 'Объявления {count} групп',
    'many-groups-phrases': 'Фразы {count} групп',
    'many-groups-targetings': 'Условия показа {count} групп',
    'minus-phrase-binding-error-grid-alert-message':
        'К этим группам не удалось привязать наборы минус-фраз. Возможно, уже привязано максимальное количество наборов',
    'minus-phrase-unbinding-error-grid-alert-message':
        'У этих групп не удалось отвязать наборы минус-фраз',
    'one-campaign-banners': 'Объявления {count} кампании',
    'one-campaign-groups': 'Группы {count} кампании',
    'one-campaign-phrases': 'Фразы {count} кампании',
    'one-campaign-targetings': 'Условия показа {count} кампании',
    'one-group-banners': 'Объявления {count} группы',
    'one-group-phrases': 'Фразы {count} группы',
    'one-group-targetings': 'Условия показа {count} группы',
    phrases: 'Фразы',
    'single-campaign-banners': 'Объявления кампании {name}',
    'single-campaign-groups': 'Группы кампании {name}',
    'single-campaign-phrases': 'Фразы кампании {name}',
    'single-campaign-targetings': 'Условия показа кампании {name}',
    'single-group-banners': 'Объявления группы {name}',
    'single-group-phrases': 'Фразы группы {name}',
    'single-group-targetings': 'Условия показа группы {name}',
    'some-campaign-entities': '{entityName} кампаний {campaignName}',
    'some-campaign-entity': '{entityName} кампании {campaignName}',
    'some-campaigns-banners': 'Объявления {count} кампаний',
    'some-campaigns-groups': 'Группы {count} кампаний',
    'some-campaigns-phrases': 'Фразы {count} кампаний',
    'some-campaigns-targetings': 'Условия показа {count} кампаний',
    'some-groups-banners': 'Объявления {count} групп',
    'some-groups-phrases': 'Фразы {count} групп',
    'some-groups-targetings': 'Условия показа {count} групп',
    targetings: 'Таргетинги'
};
